import styled from 'styled-components';

import { Button as BreweryButton } from '@xing-com/button';
import { spaceL, space3XL } from '@xing-com/tokens';

const CenterContainer = styled.div`
  text-align: center;
  padding-top: ${space3XL};
`;

const Button = styled(BreweryButton)`
  margin-top: ${spaceL};
  width: 240px;
`;

export const Styled = {
  CenterContainer,
  Button,
};
